var _path, _mask, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36365 0.5H18.6361C18.9123 0.5 19.1361 0.723858 19.1361 1V3.33984H4.86365V1C4.86365 0.723857 5.08751 0.5 5.36365 0.5Z",
    fill: "white",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4975_1812",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.32625,
    width: 24,
    height: 13.312,
    rx: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.32625,
    width: 24,
    height: 13.312,
    rx: 1.5,
    stroke: "white",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_4975_1812)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.86365,
    y: 12.02,
    width: 14.2727,
    height: 11.48,
    rx: 1,
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 7.20002C16.5 6.7582 16.6199 6.40002 16.7679 6.40002H19.9821C20.1301 6.40002 20.25 6.7582 20.25 7.20002C20.25 7.64185 20.1301 8.00002 19.9821 8.00002H16.7679C16.6199 8.00002 16.5 7.64185 16.5 7.20002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterWhite);
export default __webpack_public_path__ + "static/media/printerWhite.758e2b1d0f1f768aa646178e5aa1e67e.svg";
export { ForwardRef as ReactComponent };